/**
 * 
 * ExpandableContentList.js
 * 
 */
export default class ExpandableContentList {

    constructor() {
        this.name = 'ExpandableContentList';
        this.expandableContentLists            = document.querySelectorAll('.js-expandable-content-list');

        if (this.expandableContentLists.length) {
            this._init();
        }
    }

    // Public Functions
    
    
    // 'Private' Functions
    _init() {
        /**
         * 
         *  Loop through all Accordion Lists, and enable them 
         * 
         * */
        for (var i = 0; i < this.expandableContentLists.length; i ++) {

            let expandableContentList = this.expandableContentLists[i];
            
            this._initExpandableContentList(expandableContentList);
        }
    }

    _initExpandableContentList(expandableContentList) {

        let listItems = expandableContentList.querySelectorAll('.item');

        for (let i = 0; i < listItems.length; i ++) {
            let item = listItems[i];
            let moreLessBtn = item.querySelector('.more-less-btn');

            if (moreLessBtn) {
                moreLessBtn.addEventListener('click', (e) => {
                    this._handleListItemClick(e, item);
                });
            }
        }
    }

    _handleListItemClick(e, item) {

        let title = item.querySelector('.title');
        let titleHeight = title.clientHeight;
        
        let allContent = item.querySelector('.content');
        
        let partialContent = item.querySelector('.partial-content');
        let partialContentHeight = partialContent.clientHeight;
        
        let fullContent = item.querySelector('.full-content');
        let fullContentHeight = fullContent.clientHeight;
        
        let closedHeight = titleHeight + partialContentHeight - 24;
        let expandedHeight = titleHeight + fullContentHeight - 24;

        let moreLessBtn = item.querySelector('.more-less-btn');

        if (!item.classList.contains('expanded')) {
            moreLessBtn.innerHTML = "- Less";

            TweenMax.to(partialContent, 0.5, { opacity: 0 });
            TweenMax.to(fullContent, 0.5, { opacity: 1 });
            TweenMax.to(allContent, 0.5, { height: expandedHeight, onComplete: () => {
                item.classList.add('expanded');
            } });
        } else {
            item.classList.remove('expanded');
            moreLessBtn.innerHTML = "+ More";

            TweenMax.to(partialContent, 0.5, { opacity: 1 });
            TweenMax.to(fullContent, 0.5, { opacity: 0 });
            TweenMax.to(allContent, 0.5, { height: closedHeight, onComplete: () => {
                allContent.style.height = 'auto';
            } });
        }
    }
}
